import AuthForm from '../components/forms/AuthForm';

function Login() {
  return <AuthForm route="token/" method="login" />;
}

export default Login;